<template>
  <div>
    <EngineerItem v-for="d, idx in form.damagedata.engineer" :key="d.id" :id="d.id" :idx="idx"
      @update:modelValue="models[d.id] = $event" />
    <AddBtn class="addbtn_mobincmargin" @click="addItem">Добавить оборудование</AddBtn>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AddBtn from '../../AddBtn.vue';
import EngineerItem from './EngineerItem.vue';
import { engineerTemplate } from '@/helpers/data';

export default {
  components: { EngineerItem, AddBtn },
  data: () => ({
    engineerTemplate,
    models: {}
  }),
  props: {
    modelValue: { type: Boolean, default: false },
  },
  beforeMount() {
    if (!this.form.damagedata.engineer.length) {
      this.addItem()
    }
  },
  methods: {
    addItem() {
      this.$store.commit('addEngineer', engineerTemplate())
    },
  },
  computed: {
    ...mapState(['form']),
    filled() {
      for (let { id } of this.form.damagedata.engineer)
        if (!this.models[id])
          return false
      return true
    },
  },
  watch: {
    filled: {
      handler(v) {
        this.$emit('update:modelValue', v)
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass">
</style>